import { LocaleName } from '~/types'

export const CHANGE_LOCALE = 'CHANGE_LOCALE'

export const changeLocale = (locale: LocaleName) =>
  ({
    type: CHANGE_LOCALE,
    payload: locale,
  }) as const
